import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";
import Layout from "@/_LayoutsRelated/layout/Layout";
import BNPLMobileFormHeader from "@/pages/checkout/bnpl/common/components/BNPLMobileFormHeader";
import { Stepper } from "@/components/ui/stepper";
import { CarSpecsHeader } from "@/components/ui/car-specs-header";
import SplitPaymentDetails from "@/pages/split-payment/components/SplitPaymentDetails";
import WarrantyBanner from "@/pages/split-payment/components/WarrantyBanner";
import OtpVerification from "@/_MiniApps/auth/ui/OTP/OtpVerification";
import Loader from "@componentsShared/Loader/Loader";
import { BottomSheet as LegacyBottomSheet } from "@componentsShared/BottomSheet";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import { CDN_LINK } from "@globalConfig";
import CreditCardForm from "@/pages/checkout/credit-card/components/CreditCardForm";
import { useTranslation } from "@i18n";
import { useLang } from "@/common/Contexts/LanguageContext";
import useHelpers from "@hooks/useHelpers";
import useIsMobile from "@hooks/useIsMobile";
import useBoolean from "@hooks/useBoolean";
import useLocalStorage from "@hooks/useLocalStorage";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { useCreditCardCheckout } from "@/common/Contexts/CreditCardCheckoutContext";
import { resolveRoadServiceId } from "@/_MiniApps/RoadsideAssistance";
import { handleHasAccountEvent } from "@/utils/common";
import { api__createCreditCardOrderV2 } from "@/apis/orders/orders";
import { dispatchButtonLoading } from "@hooks/useButtonLoading";
import { ValidationException } from "@/common/exceptions/ValidationException";
import { toast } from "sonner";
var CreditCardCheckout = function CreditCardCheckout() {
  var _checkoutOrderV2$id, _checkoutOrderV2$sect, _checkoutOrderV2$sect2, _checkoutOrderV2$sect3, _carHeader$specs, _formData$warranty_id, _carHeader$car_title, _formData$warranty_id2;
  if (__IS_SSR__) return /*#__PURE__*/React.createElement(Loader, null);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var lang = useLang();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    navigateToHard = _useHelpers.navigateToHard;
  var isMobile = useIsMobile();
  var isDesktop = !isMobile;
  var _useLocalStorage = useLocalStorage(),
    setLocalStorage = _useLocalStorage.setLocalStorage,
    removeLocalStorage = _useLocalStorage.removeLocalStorage;
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn;
  var _useState = useState(false),
    showOtp = _useState[0],
    setShowOtp = _useState[1];
  // form payload kept until the order can be created (after OTP — create endpoint needs auth)
  var _useState2 = useState(null),
    pendingPayload = _useState2[0],
    setPendingPayload = _useState2[1];
  var _useCreditCardCheckou = useCreditCardCheckout().state,
    checkoutOrderV2 = _useCreditCardCheckou.checkoutOrderV2,
    formData = _useCreditCardCheckou.formData,
    fetch_loading = _useCreditCardCheckou.fetch_loading;
  var post_id = useCreditCardCheckout().queryParams.post_id;
  var setFormItem = useCreditCardCheckout().actions.setFormItem;
  var _useCreditCardCheckou2 = useCreditCardCheckout().remote_actions,
    fetch__getOrderWithPaymentInfoV2 = _useCreditCardCheckou2.fetch__getOrderWithPaymentInfoV2,
    fetch__getOrderDetailsByParamsV2 = _useCreditCardCheckou2.fetch__getOrderDetailsByParamsV2;
  var grantedPopup = useBoolean();
  useEffect(function () {
    if (checkoutOrderV2 !== null && checkoutOrderV2 !== void 0 && checkoutOrderV2.id) {
      fetch__getOrderWithPaymentInfoV2(post_id, {
        order_id: checkoutOrderV2.id
      });
    }
  }, [checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.id]);
  var goToPayment = function goToPayment(orderId) {
    navigateToHard("/checkout/create-araboon?post_id=".concat(post_id, "&order_id=").concat(orderId));
  };

  // create the credit-card order (auth is guaranteed here: logged-in, or just verified via OTP)
  var createOrderAndGo = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(payload) {
      var otpVerified,
        order,
        orderId,
        _args = arguments,
        _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            otpVerified = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
            dispatchButtonLoading(true);
            _context.p = 1;
            _context.n = 2;
            return api__createCreditCardOrderV2(_objectSpread(_objectSpread(_objectSpread({}, payload), formData !== null && formData !== void 0 && formData.warranty_id ? {
              warranty_id: Number(formData.warranty_id)
            } : {}), (formData === null || formData === void 0 ? void 0 : formData.road_service_id) != null ? {
              road_service_id: Number(formData.road_service_id)
            } : {}));
          case 2:
            order = _context.v;
            orderId = order === null || order === void 0 ? void 0 : order.id;
            if (orderId) {
              _context.n = 3;
              break;
            }
            console.error("credit-card create: unexpected response shape", order);
            toast.error(t("error_occurred_while_creating_request", {
              ns: "web_checkout_cash"
            }), {
              position: "bottom-center"
            });
            setShowOtp(false); // don't leave the user stuck on the OTP loader
            return _context.a(2);
          case 3:
            // the Arboon page (Checkout.tsx) shows the "verify code" step purely from this flag.
            // set it only when OTP actually ran; clear any stale value for logged-in users so the
            // tab doesn't reappear on re-tests of the same order_id.
            if (otpVerified) setLocalStorage("otp_visited_".concat(orderId), "1");else removeLocalStorage("otp_visited_".concat(orderId));
            sessionStorage.setItem("cc_order_".concat(orderId), "1");
            goToPayment(orderId);
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            setShowOtp(false);
            if (_t instanceof ValidationException) {
              toast.error(_t.getAllErrorMessages(), {
                position: "bottom-center"
              });
            } else {
              toast.error((_t === null || _t === void 0 ? void 0 : _t.message) || t("error_occurred_while_creating_request", {
                ns: "web_checkout_cash"
              }), {
                position: "bottom-center"
              });
            }
          case 5:
            _context.p = 5;
            dispatchButtonLoading(false);
            return _context.f(5);
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[1, 4, 5, 6]]);
    }));
    return function createOrderAndGo(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var handleComplete = function handleComplete(payload, requiresOtp) {
    setPendingPayload(payload);
    if (requiresOtp) {
      setShowOtp(true);
      return;
    }
    createOrderAndGo(payload);
  };
  var verifyOtpCb = function verifyOtpCb(userData) {
    if (!pendingPayload) return;
    handleHasAccountEvent({
      hasAccount: userData.has_account,
      status: "Success",
      phone_number: pendingPayload.phone_number,
      lang: lang,
      referral_location: "credit_card_order"
    });
    createOrderAndGo(pendingPayload, true);
  };
  var handleExit = function handleExit(hard) {
    if (showOtp) {
      setShowOtp(false);
      return;
    }
    if (hard) {
      navigateToHard("/cardetail/".concat(post_id));
    } else {
      navigateTo("/cardetail/".concat(post_id));
    }
  };
  var otpStep = /*#__PURE__*/React.createElement(OtpVerification, {
    FIX_ME__extra_params: {
      order_id: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$id = checkoutOrderV2.id) === null || _checkoutOrderV2$id === void 0 ? void 0 : _checkoutOrderV2$id.toString()
    },
    source: "credit_card",
    after_verify_callback: verifyOtpCb,
    scenario: "signup",
    phone_number: pendingPayload === null || pendingPayload === void 0 ? void 0 : pendingPayload.phone_number,
    onEditNumber: function onEditNumber() {
      return setShowOtp(false);
    },
    design: {
      btnText: tShort("phone_number_verification", {
        ns: "otp_screen"
      }),
      label: tShort("enter_code_sent_to", {
        ns: "otp_screen"
      }),
      withborder: false
    }
  });
  var main_render = function main_render() {
    return /*#__PURE__*/React.createElement(CreditCardForm, {
      onComplete: handleComplete
    });
  };
  var steps = [{
    id: "info",
    label: tShort("steps/add_information")
  }, {
    id: "payment",
    label: tShort("steps/payment")
  }];

  // Desktop specs bar above the main card (Figma)
  var carHeader = checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$sect = checkoutOrderV2.sections) === null || _checkoutOrderV2$sect === void 0 ? void 0 : (_checkoutOrderV2$sect2 = _checkoutOrderV2$sect.find(function (s) {
    return s.type === "car_header";
  })) === null || _checkoutOrderV2$sect2 === void 0 ? void 0 : (_checkoutOrderV2$sect3 = _checkoutOrderV2$sect2.items) === null || _checkoutOrderV2$sect3 === void 0 ? void 0 : _checkoutOrderV2$sect3[0];
  var carSpecs = ((_carHeader$specs = carHeader === null || carHeader === void 0 ? void 0 : carHeader.specs) !== null && _carHeader$specs !== void 0 ? _carHeader$specs : []).map(function (s) {
    return {
      label: s.label,
      value: s.value
    };
  });
  return /*#__PURE__*/React.createElement(Layout, {
    disableLoader: true,
    loading: fetch_loading,
    authenticationMsg: true,
    mainClass: "CheckOut",
    logoNotClickable: true,
    headHideLinks: true,
    hideMenu: true,
    hideAppBanner: true,
    hideHeaderOnmobile: true,
    custommobileHeader: isMobile && /*#__PURE__*/React.createElement(BNPLMobileFormHeader, {
      title: tShort("credit_card/page_title", {
        ns: "web_checkout_cash"
      }),
      onBack: function onBack() {
        return handleExit(false);
      }
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative mx-auto !mt-0 w-full max-w-[1152px] !pt-2 after:fixed after:bottom-0 after:left-0 after:z-[-1] after:h-full after:w-full after:bg-[#f4f7fb] after:content-[''] sm:!w-[90%] sm:after:bg-[#fbfcff] md:!mt-8 md:!pt-0 lg:!w-[80%]"
  }, /*#__PURE__*/React.createElement(Stepper, {
    steps: steps,
    currentStep: 1,
    className: isMobile ? "px-4 py-3" : "mb-8"
  }), isMobile && /*#__PURE__*/React.createElement("div", {
    className: "px-4 pb-4 pt-3"
  }, /*#__PURE__*/React.createElement(WarrantyBanner, {
    checkoutOrderV2: checkoutOrderV2,
    orderType: "credit_card",
    referralLocation: "checkout",
    preferredWarrantyId: (_formData$warranty_id = formData === null || formData === void 0 ? void 0 : formData.warranty_id) !== null && _formData$warranty_id !== void 0 ? _formData$warranty_id : null,
    onWarrantyChange: (/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(id) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              setFormItem("warranty_id", id);
              _context2.n = 1;
              return fetch__getOrderDetailsByParamsV2(post_id, _objectSpread({
                city_id: formData !== null && formData !== void 0 && formData.city_id ? Number(formData.city_id) : undefined,
                warranty_id: id
              }, resolveRoadServiceId(checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.sections) != null ? {
                road_service_id: resolveRoadServiceId(checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.sections)
              } : {}));
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }())
  })), isDesktop && carHeader && /*#__PURE__*/React.createElement(CarSpecsHeader, {
    image: carHeader.car_image,
    imageAlt: carHeader.car_title,
    subtitle: carHeader.car_origin,
    title: (_carHeader$car_title = carHeader.car_title) !== null && _carHeader$car_title !== void 0 ? _carHeader$car_title : "",
    specs: carSpecs,
    className: "mb-7"
  }), /*#__PURE__*/React.createElement("div", {
    className: twMerge("mt-0 flex flex-col-reverse items-start justify-between sm:flex-row", isDesktop && "gap-[22px] md:!mt-4", isDesktop && "sm:gap-6 sm:rounded-2xl sm:border sm:border-solid sm:border-[#e1e8f2] sm:bg-white sm:py-8 sm:shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.08),0px_1px_3px_0px_rgba(0,0,0,0.08)]")
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge("relative w-full sm:min-w-0 sm:flex-1", isMobile && "pb-[160px]", isDesktop && "px-6")
  }, main_render()), isDesktop && /*#__PURE__*/React.createElement("div", {
    id: "checkout-payment-container",
    className: "w-full sm:w-[43%] sm:flex-none sm:px-6 sm:pb-8"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "mb-4 py-2 text-xl font-bold text-[#00143c]"
  }, tShort("flexible_payment/details_title", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement(SplitPaymentDetails, {
    loading: fetch_loading || !checkoutOrderV2,
    checkoutOrderV2: checkoutOrderV2,
    warrantyOrderType: "credit_card",
    showWarrantySection: !showOtp,
    selectedWarrantyId: (_formData$warranty_id2 = formData === null || formData === void 0 ? void 0 : formData.warranty_id) !== null && _formData$warranty_id2 !== void 0 ? _formData$warranty_id2 : null,
    onWarrantySelected: (/*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(id) {
        var saved, existing;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              setFormItem("warranty_id", id);
              try {
                saved = sessionStorage.getItem("credit_card_form_data_".concat(post_id));
                existing = saved ? JSON.parse(saved) : {};
                sessionStorage.setItem("credit_card_form_data_".concat(post_id), JSON.stringify(_objectSpread(_objectSpread({}, existing), {}, {
                  warranty_id: id
                })));
              } catch (_unused) {
                // sessionStorage full or unavailable
              }
              _context3.n = 1;
              return fetch__getOrderDetailsByParamsV2(post_id, _objectSpread({
                city_id: formData !== null && formData !== void 0 && formData.city_id ? Number(formData.city_id) : undefined,
                warranty_id: id
              }, resolveRoadServiceId(checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.sections) != null ? {
                road_service_id: resolveRoadServiceId(checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.sections)
              } : {}));
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }())
  }))), /*#__PURE__*/React.createElement(LegacyBottomSheet, {
    open: showOtp,
    onOpen: function onOpen() {},
    onClose: function onClose() {
      return setShowOtp(false);
    },
    screens: [{
      key: "credit-card-otp",
      component: otpStep
    }],
    hideTitleBar: true,
    haveClose: true,
    customClassName: "modalHideHeader",
    maxWidthDesktop: "900px",
    maxHeight: "76vh"
  }), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: grantedPopup.value,
    onClose: grantedPopup.setFalse,
    containerClassName: "!z-[999999999]",
    showXMob: true,
    mobileDesignChange1: "1"
  }, function (_checkoutOrderV2$sect4, _checkoutOrderV2$sect5, _noteInfo$title, _noteInfo$description) {
    var noteInfo = checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$sect4 = checkoutOrderV2.sections) === null || _checkoutOrderV2$sect4 === void 0 ? void 0 : (_checkoutOrderV2$sect5 = _checkoutOrderV2$sect4.flatMap(function (s) {
      var _s$items;
      return (_s$items = s.items) !== null && _s$items !== void 0 ? _s$items : [];
    }).find(function (item) {
      return item.show_note && item.note_info;
    })) === null || _checkoutOrderV2$sect5 === void 0 ? void 0 : _checkoutOrderV2$sect5.note_info;
    var iconName = noteInfo === null || noteInfo === void 0 ? void 0 : noteInfo.icon_svg;
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-center justify-center gap-8 p-[13px] pt-12"
    }, /*#__PURE__*/React.createElement("img", {
      src: CDN_LINK + "/assets/images/".concat(iconName, ".svg"),
      width: "96px",
      height: "82px",
      alt: "icon"
    }), /*#__PURE__*/React.createElement("strong", {
      className: "text-[#3C56D4] text-center text-[32px] font-bold leading-[32px]"
    }, (_noteInfo$title = noteInfo === null || noteInfo === void 0 ? void 0 : noteInfo.title) !== null && _noteInfo$title !== void 0 ? _noteInfo$title : t("shipping_cost_2", {
      ns: "web_checkout_cash"
    })), /*#__PURE__*/React.createElement("p", {
      className: "text-[#3C56D4] text-center font-[Cairo] text-[20px] font-semibold leading-[32px]"
    }, (_noteInfo$description = noteInfo === null || noteInfo === void 0 ? void 0 : noteInfo.description) !== null && _noteInfo$description !== void 0 ? _noteInfo$description : t("shipping_cost_determined_sales_representative", {
      ns: "web_checkout_cash"
    })));
  }())));
};
export default CreditCardCheckout;